// ============================================
// Seed Templates: Dashboards & Tools
// Category: dashboards-tools
// Templates: 4
// ============================================

import type { DocTemplate } from '../../types/docops';

export const SEED_TEMPLATES_DASHBOARDS: DocTemplate[] = [
  // ── 9.1 Formulary Management Dashboard ──
  {
    id: '9.1-formulary-dashboard',
    categoryId: 'dashboards-tools',
    track: 'operational',
    title: 'Formulary Management Dashboard',
    description:
      'Admin dashboard for managing supplement products, bundles, and safety rules.',
    templateContent: '',
    requiredVariables: ['brandName'],
    generationPrompt:
      'Already built. Located at /admin (FormularyDashboard, ProductList, BundleList, SafetyRuleList components).',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 1,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 9.2 Regulatory Intelligence Dashboard ──
  {
    id: '9.2-regulatory-dashboard',
    categoryId: 'dashboards-tools',
    track: 'operational',
    title: 'Regulatory Intelligence Dashboard',
    description:
      'Dashboard for tracking regulatory alerts, policies, and notification campaigns.',
    templateContent: '',
    requiredVariables: ['brandName'],
    generationPrompt:
      'Already built. Located at /admin/regulatory (RegulatoryDashboard component).',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 2,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 9.3 Data Operations Dashboard ──
  {
    id: '9.3-dataops-dashboard',
    categoryId: 'dashboards-tools',
    track: 'operational',
    title: 'Data Operations Dashboard',
    description:
      'Dashboard for compliance tracking, data requests, consent management, retention, breach detection, and audit logging.',
    templateContent: '',
    requiredVariables: ['brandName'],
    generationPrompt:
      'Already built. Located at /admin/data-ops (DataOpsDashboard component).',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 3,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 9.4 Vendor Management Dashboard ──
  {
    id: '9.4-vendor-dashboard',
    categoryId: 'dashboards-tools',
    track: 'operational',
    title: 'Vendor Management Dashboard',
    description:
      'Vendor-facing dashboard for order management and fulfillment tracking.',
    templateContent: '',
    requiredVariables: ['brandName'],
    generationPrompt:
      'Already built. Located at /vendor (VendorDashboard, VendorOrderList, VendorOrderDetail components).',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 4,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },
];
